// extracted by mini-css-extract-plugin
module.exports = {"root":"a10a3f92e9--root--ejskK","row":"a10a3f92e9--row--twJK8","price":"a10a3f92e9--price--VkWpf"};